let appcues = { active: false }

if (land_tender?.appcues?.active) {
  window.addEventListener('phx:set-user-feature-flags', ({ detail }) => {
    if (typeof Appcues != 'undefined' && land_tender.user) {
      Appcues.identify(land_tender.user.ref, {
        feature_flags: detail.features
      })
    }
  })

  window.addEventListener('phx:page-loading-stop', ({ detail }) => {
    if (
      detail.kind === 'initial' &&
      typeof Appcues != 'undefined' &&
      land_tender.user
    ) {
      Appcues.identify(land_tender.user.ref, {
        email: land_tender.user.email,
        orgRef: land_tender.user.orgRef,
        orgCode: land_tender.user.orgCode,
        role: land_tender.user.role,
        groupRef: land_tender.user.groupRef,
        groupCode: land_tender.user.groupCode,
        env: land_tender.mix_env,
        logRocketSessionUrl: land_tender.user.logRocketSessionUrl
      })
    }
  })

  appcues.active = true
}

export { appcues }
